<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>库存管理</el-breadcrumb-item>
      <el-breadcrumb-item>库存打印</el-breadcrumb-item>
    </el-breadcrumb>
      <el-button style="margin-right: 1px" size="mini" v-print="'#printMe'" @click="printEd">打印</el-button>
      <div id="printMe" >
        <p>库存打印</p>
        <div style="height: 2500px">
          <el-table height="2500px" :data="productList" fit border stripe="stripe"
                    :header-cell-style="{background:'#eff3f8', color:'#333'}"
                    :row-style="{height: '0'}">
            <el-table-column
              align="center"
              prop="productName"
              label="产品名称">
            </el-table-column>
            <!--        <el-table-column-->
            <!--          align="center"-->
            <!--          prop="productNo"-->
            <!--          label="产品编号">-->
            <!--        </el-table-column>-->
            <el-table-column
              align="center"
              prop="psm"
              label="规格型号" width="80">
            </el-table-column>
            <el-table-column
              align="center"
              prop="unit"
              label="单位" width="80">
            </el-table-column>
            <el-table-column
              align="center"
              prop="nowNum"
              label="现有库存"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="practicalNum"
              label="实际库存">
            </el-table-column>
          </el-table>
        </div>
      </div>
        <div style="margin-top: 3px;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageTotal">
          </el-pagination>
        </div>


  </div>
</template>

<script>
export default {
  data(){
    return{
      currentOrgId:'',
      authorities:'',
      userId:'',
      orgLevel:'',
      productList:[],
      baseRequest:{
        orgId: '',
        pageNum: '',
        pageSize:'',
      },
      currentPage: 1,
      pageSize:200,
      pageTotal:0,
    }
  },
  methods:{
    async printEd(){

    },
    loadProduct(){
      this.baseRequest.orgId = this.currentOrgId;
      this.baseRequest.pageNum = this.currentPage;
      this.baseRequest.pageSize = this.pageSize;
      this.loadProductTotal();
      this.loadProductList();
    },
    async loadProductTotal(){
      const {data:res} = await this.$http.post(`/stock/print/total/`, this.baseRequest);
      if (res.code === 200){
        this.pageTotal = res.totalPage;
      }
    },
    async loadProductList(){
      const {data:res} = await this.$http.post(`/stock/print/list/`, this.baseRequest);
      if (res.code === 200){
        this.productList = res.data;
      }
    },
    handleSizeChange(val) {
      this.baseRequest.pageSize = val;
      this.loadProductList();
    },
    handleCurrentChange(val) {
      this.baseRequest.currentPage = val;
      this.loadProductList();
    },
  },
  created() {
    this.currentOrgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.orgLevel = window.sessionStorage.getItem('orgLevel');
    this.loadProduct();
  }
}
</script>

<style lang="less" scoped>
.container{
  height: 90vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 92vh;
  background-color: #eff3f8;
}
.left_con{
  display: flex;
  justify-content: start;
  height: 100%;
  overflow-y: auto;
  //flex: 1;
  width: auto;
  //border: 1px solid;
  margin: 10px 0;
  //width: 100px;
}
.left_inner_con{
  width: 300px;
  height: 98%;
  overflow-y: auto;
  background-color: #F2F6FC;
}
.box-card{
  margin: 10px 10px 10px 10px;
  height: 87%;
}
/deep/ .el-dialog{
  background: #fafaff !important;
}
/deep/ .el-dialog__header{
  padding: 15px 20px 10px;
}
/deep/ .el-dialog__body{
  padding: 5px 25px;
  color:#606266;
  font-size:14px;
  word-break:break-all;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
    text-align: center !important;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/ .el-drawer__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
.dialog-footer{
  display: flex;
  margin: 10px 0;
  justify-content: center;
  width: 100%;
}
.table_container{
  flex: 1;
  width: 800px;
  height: 95%;
}
</style>



// WEBPACK FOOTER //
// src/components/StockPrint.vue